$(document).ready(function () {
  const $confirmationPopup      = $('#cart-confirmation-popup');
  const $confirmationPopupInner = $('.inner-popup');
  const $confirmButton          = $('#confirmCart');
  const $cartSubmitButton       = $('.product-form__cart-submit');

  $('.product-form-btn').removeClass('hidden');
  $cartSubmitButton.addClass('hidden');

  $(document).on('click', '.product-form-btn', function (event) {
    const $btn = $(this);

    if ($btn.hasClass('cart-button')) {
      event.preventDefault();

      $confirmationPopup.removeClass('hidden');
      $('body').css('overflow', 'hidden');

      setTimeout(() => {
        $btn.addClass('hidden');
        $cartSubmitButton.removeClass('hidden');
      }, 500);

      setTimeout(() => {
        $confirmationPopupInner.focus();
      }, 200);

      return;
    }
  });

  $confirmButton.on('click', function () {
    $cartSubmitButton.trigger('click');
    closePopup();
  });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape' && !$confirmationPopup.hasClass('hidden')) {
      closePopup();
    }
  });

  $('body').on('click', '.closebtn', function () {
    closePopup();
  });

  function closePopup() {
    $confirmationPopup.addClass('hidden');
    $('body').css('overflow', 'auto');
    $('.product-form-btn.cart-button').removeClass('hidden');
    $cartSubmitButton.addClass('hidden');
    $('.product-form-btn.cart-button').focus();
  }
});
